<template>
  <div class="navtopfixed">
    <i class="minscreen iconfont icon-caidan" @click="drawer = true" type="primary"></i>
    <el-drawer
      :title="$t('lang.menu')"
      :visible.sync="drawer"
      :append-to-body="true"
      :size="navwidth"
      :modal-append-to-body="false"
      direction="ltr"
      :with-header="false"
    
    >
      <div class="minnavWidthdiv">
        <ul class="minnavWidth" :style="{left:`${moveLeft}px`}">
          <li
            class="minlistdiv"
            v-for="(item,index) in navlist"
            :key="index"
            @click="clickactivelist(item.menu_id,item.portal_routes,index)"
          >
            <div
              v-show="i18n_locale!='en-US'"
              :class="{minactivelist:activelistsumnav==index}"
            >{{item.menu_name}}</div>
            <div
              v-show="i18n_locale=='en-US'"
              :class="{minactivelist:activelistsumnav==index}"
            >{{compword(item.english_name)}}</div>
          </li>
        </ul>
      </div>
    </el-drawer>
    <div
      class="maxscreen navpositionrelaAll navbackgournd"
      :style="{'background-color':all_app_color}"
    >
      <div class="allWidth allmenu navpositionrela" :style="{'background-color':all_app_color}">
        <div
          v-show="iconLeftShow"
          style="cursor:pointer;"
          class="lefticon iconfont icon-you"
          @click="navRight"
        ></div>
        <div class="overhidden">
          <ul class="navWidth calss_set_font_size" :style="{left:`${moveLeft}px`}">
            <li
              class="listdiv"
              v-for="(item,index) in navlist"
              :key="index"
              @click="clickactivelist(item.menu_id,item.portal_routes,index)"
            >
              <div
                :style="{'background-color':'#ffffff'}"
                :class="{nav_line:activelistsumnav==index}"
              ></div>
              <div
                v-show="i18n_locale!='en-US'"
                :class="{activelist:activelistsumnav==index}"
              >{{item.menu_name}}</div>
              <div
                v-show="i18n_locale=='en-US'"
                :class="{activelist:activelistsumnav==index}"
              >{{compword(item.english_name)}}</div>
            </li>
          </ul>
        </div>
        <div
          v-show="iconRightShow"
          style="cursor:pointer;"
          @click="navLenght"
          class="righticon iconfont icon-zuo"
        ></div>
      </div>
    </div>
    <div v-show="false">{{all_app_color_comp}}{{i18n_locale__}}{{ture_false__}}</div>
  </div>
</template>

<script>
import * as serviceApi from "./api/nav";
export default {
  data() {
    return {
      i18n_locale: "",
      all_app_color: "#3b9dce",
      moveLeft: 0,
      activelistsum: 0,
      iconLeftShow: true,
      iconRightShow: true,
      navlist: [],
      onenavlist: {
        menu_id: "000",
        menu_name: "首页",
        english_name: "HOME",
        portal_routes: "/home"
      },
      clientWidthmub: 9,
      drawer: false,
      navwidth: "30%"
    };
  },
  //挂载监听函数
  destroyed() {
    window.removeEventListener("beforeunload", this.updateHandler);
  },
  methods: {
    // drawer_close(){
    //   console.log(this.drawer);
    //   if (!this.drawer) {
    //     this.$store.commit("change_ture_false_click_nav", false);
    //   }
    // },
    created_change_home_nav_list(allnav) {
      let data = {};
      let length = allnav.length;
      for (let i = 0; i < length; i++) {
        if (allnav[i].portal_routes == "/ktzintroduce") {
          data.ktzjs = true;
        } else if (allnav[i].portal_routes == "/researchdirection") {
          data.yjfx = true;
        } else if (allnav[i].portal_routes == "/researchprogress") {
          data.cgzs = true;
        } else if (allnav[i].portal_routes == "/dynamic") {
          data.dt = true;
        } else if (allnav[i].portal_routes == "/researchequipment") {
          data.kysb = true;
        } else if (allnav[i].portal_routes == "/teamintroduction") {
          data.cygl = true;
        } else if (allnav[i].portal_routes == "/principalIntroduce") {
          data.principalIntroduce = true;
        }
      }
      this.$store.commit("change_home_nav_list", data);
    },
    //页面刷新前
    updateHandler() {
      window.sessionStorage.removeItem("moveLeft");
      window.sessionStorage.removeItem("activelistsum");
      sessionStorage.setItem("moveLeft", this.moveLeft);
      sessionStorage.setItem("activelistsum", this.$store.state.activelistsum);
    },
    //监听屏幕大小
    screesum() {
      if (document.body.clientWidth >= 1200) {
        this.clientWidthmub = 9;
      } else if (
        document.body.clientWidth > 992 &&
        document.body.clientWidth <= 1199
      ) {
        this.clientWidthmub = 7;
      } else if (
        document.body.clientWidth > 768 &&
        document.body.clientWidth <= 991
      ) {
        this.clientWidthmub = 6;
      }
    },
    //请求导航栏菜单
    RequestgetnavDataList() {
      let that = this;
      let allnavlist = [];
      // this.navlist = [];
      serviceApi.getnavDataList({}).then(body => {
        allnavlist = body.data;
        that.navlist = allnavlist.filter(function(item) {
          return item.is_hide == 0;
        });
        that.navlist.splice(0, 0, that.onenavlist);
        if (!this.$store.state.have_value) {
          that.created_change_home_nav_list(that.navlist); //将所有的菜单列表放到函数中，循环判断，是否在首页点击指定链接时跳转
        }

        that.$store.commit("ischangenav", that.navlist);
        let aaa = this.$router.currentRoute.path;
        let arr = this.$store.state.navlistdata;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].portal_routes == aaa) {
            this.$store.commit("isclicknavactive", i);
            // return;
          }
          // return;
        }
        that.moutednavicon();
      });
    },
    //点击导航栏菜单事件
    clickactivelist(index, url, indexx) {
      // let aaa = this.$router.currentRoute.path;
      // let arr = this.$store.state.navlistdata;
      // for (let i = 0; i < this.$store.state.navlistdata.length; i++) {
      //   if (arr[i].portal_routes == aaa) {
      //     this.$store.commit("isclicknavactive", i);
      //             return;
      //   }
      if (this.$router.currentRoute.path == url) {
        this.$store.commit("TWLBXQ", url);
        return;
      }
      this.$router.push(url);
      this.$store.commit("isclicknavactive", indexx);
      // this.activelistsum = index;
      // this.$router.push(url);
      this.$store.commit("changenavdata", this.navlist[indexx]);
    },
    // 点击左边的按钮 如果到最右边了就隐藏左边的按钮
    navLenght() {
      this.moveLeft -= 124;
      this.$store.commit("ismovenav", this.moveLeft);
      this.moutednavicon();
      // if (-124 * (this.navlist.length - this.clientWidthmub) >= this.moveLeft) {
      //   this.iconLeftShow = true;
      //   this.iconRightShow = false;
      //   return;
      // } else {
      //   if (
      //     -124 * (this.navlist.length - this.clientWidthmub) ==
      //     this.moveLeft
      //   ) {
      //     this.iconLeftShow = true;
      //     this.iconRightShow = false;
      //   }
      //   if (this.moveLeft == 0) {
      //     this.iconRightShow = true;
      //   } else {
      //     this.iconRightShow = true;
      //     this.iconLeftShow = true;
      //   }
      // }

      // 点击右边的按钮 如果到最右边了（left=0）就隐藏右边的按钮
      //  同时显示最左边的按钮
    },
    //点击右边的按钮
    navRight() {
      this.moveLeft += 124;
      this.$store.commit("ismovenav", this.moveLeft);
      this.moutednavicon();
      // if (0 == this.moveLeft) {
      //   this.iconRightShow = true;
      //   this.iconLeftShow = false;
      //   return;
      // } else {
      //   this.moveLeft += 124;
      //   if (this.moveLeft == 0) {
      //     this.iconRightShow = true;
      //     this.iconLeftShow = false;
      //   } else {
      //     this.iconLeftShow = true;
      //     this.iconRightShow = true;
      //   }
      // }

      // if (-124 * (this.navlist.length - this.clientWidthmub) == this.moveLeft) {
      //   this.iconRightShow = false;
      // }
    },
    // 如果开始的导航栏菜单长度小于十 就隐藏所有的按钮
    // iconShow() {
    //   if (this.navlist.length <= 10) {
    //     this.iconLeftShow = this.iconRightShow = false;
    //   } else if (this.moveLeft == 0) {
    //     this.iconLeftShow = false;
    //     this.iconRightShow = true;
    //   }
    // },
    //第一次进入时判断是否显示导航栏左右的按钮
    moutednavicon() {
      this.screesum();
      // this.moveLeft = this.$store.state.moveLeft;
      if (this.moveLeft == 0) {
        if (this.navlist.length <= this.clientWidthmub) {
          this.iconLeftShow = this.iconRightShow = false;
        } else {
          this.iconLeftShow = false;
          this.iconRightShow = true;
        }
        // this.iconRightShow = true;
      } else {
        // if (-124 * (this.navlist.length - 10) == this.moveLeft) {
        //   this.iconRightShow = false;
        // } else {
        //   this.iconRightShow = true;
        //   this.iconLeftShow = true;
        // }
        if (
          124 * (this.navlist.length - this.clientWidthmub) ==
          -this.moveLeft
        ) {
          this.iconLeftShow = true;
          this.iconRightShow = false;
          return;
        } else if (
          124 * (this.navlist.length - this.clientWidthmub) >
          -this.moveLeft
        ) {
          this.iconLeftShow = true;
          this.iconRightShow = true;
        }
      }
    }
  },
  mounted() {
    // this.navLenght();
    // this.iconShow();
    this.screesum();
    // if (document.body.clientWidth >= 1200) {
    //   this.clientWidthmub = 10;
    // } else if (
    //   document.body.clientWidth > 992 &&
    //   document.body.clientWidth <= 1199
    // ) {
    //   this.clientWidthmub = 7;
    // } else if (
    //   document.body.clientWidth > 768 &&
    //   document.body.clientWidth <= 991
    // ) {
    //   this.clientWidthmub = 6;
    // }
    //  else if (
    //   document.body.clientWidth > 480 &&
    //   document.body.clientWidth <= 767
    // ) {
    //   this.clientWidthmub = 3;
    // } else {
    //   this.clientWidthmub = 10;
    // }
    if (document.body.clientWidth < 480) {
      this.navwidth = "50%";
    } else {
      this.navwidth = "30%";
    }
    // this.moveLeft = this.$store.state.moveLeft;
  },
  computed: {
    ture_false__() {
      if (this.$store.state.ture_false_nav) {
        this.drawer = this.$store.state.ture_false_nav;
      }
     
      return "";
    },
    compword() {
      return function(val) {
        let aa = "";
        aa = val.split(" ")[0];
        return aa;
      };
    },
    i18n_locale__() {
      this.i18n_locale = this.$store.state.i18n_locale;
      return this.i18n_locale;
    },
    activelistsumnav() {
      return this.$store.state.activelistsum;
    },
    all_app_color_comp() {
      if (this.$store.state.all_app_color) {
        this.all_app_color = this.$store.state.all_app_color; //将本地的全局配色，赋值给 this.all_app_color
      }
      return "";
    }
  },

  // beforeDestroy() {
  //   this.$store.commit("ismovenav", this.moveLeft);
  // },
  // beforeRouteLeave(to, form, next) {
  //   this.$store.commit("ismovenav", this.moveLeft);
  //   // next();
  // },
  created() {
    this.i18n_locale = localStorage.getItem("locale");
    if (this.$store.state.all_app_color) {
      this.all_app_color = this.$store.state.all_app_color;
    } else {
      this.all_app_color = localStorage.getItem("all_app_color"); //将本地的全局配色，赋值给 this.all_app_color
    }
    if (
      !this.$store.state.activelistsum &&
      !this.$store.state.moveLeft &&
      this.$store.state.moveLeft !== 0 &&
      this.$store.state.activelistsum !== 0
    ) {
      // console.log(sessionStorage.getItem("moveLeft"),
      sessionStorage.getItem("activelistsum");
      if (
        sessionStorage.getItem("moveLeft") &&
        sessionStorage.getItem("activelistsum")
      ) {
        this.moveLeft = +sessionStorage.getItem("moveLeft");
        this.activelistsum = sessionStorage.getItem("activelistsum");
        this.$store.commit("isclicknavactive", this.activelistsum);
        this.$store.commit("ismovenav", this.moveLeft);
      } else {
        this.$store.commit("isclicknavactive", this.activelistsum);
        this.$store.commit("ismovenav", this.moveLeft);
        // this.$store.commit("changenavdata", this.$store.state.navlistdata[this.activelistsum]);
      }
      // that.$router.push("/home");
    } else {
      this.moveLeft = this.$store.state.moveLeft;
      this.activelistsum = this.$store.state.activelistsum;
    }

    window.addEventListener("beforeunload", this.updateHandler);
    if (this.$store.state.navlistdata.length == 0) {
      this.RequestgetnavDataList();
    } else {
      this.navlist = this.$store.state.navlistdata;
      if (!this.$store.state.have_value) {
        this.created_change_home_nav_list(this.navlist); //将所有的菜单列表放到函数中，循环判断，是否在首页点击指定链接时跳转
      }

      this.moutednavicon();
      let aaa = this.$router.currentRoute.path;
      let arr = this.$store.state.navlistdata;
      for (let i = 0; i < this.$store.state.navlistdata.length; i++) {
        if (arr[i].portal_routes == aaa) {
          this.$store.commit("isclicknavactive", i);
          // return;
        }
      }
    }
  }
  //  beforeEnter: (to, from, next) => {
  //       alert('清除监听事件');
  // }
  // computed: {
  //   iconShow:{
  //     set:function(){
  //       if (this.list.length <= 8) {
  //       this.iconLeftShow = this.iconRightShow = false;
  //     }else{
  //       if(this.moveLeft=0){
  //       this.iconLeftShow = false;
  //     }
  //     if(-145 * (this.list.length - 8) == this.moveLeft){
  //       this.iconRightShow = false;
  //     }
  //   }
  //     }
  //     }

  // }
};
</script>

<style>
.el-drawer {
  overflow-y: auto !important;
}
</style>
<style scoped>
.nav_line {
  width: 50px;
  height: 3px;
  background-color: #3b9dce;
  position: absolute;
  bottom: -1px;
  right: 50%;
  left: 50%;
  margin-left: -25px;
  border-radius: 20px;
}
.minnavWidthdiv {
  overflow-y: auto;
  height: 100%;
  display: block;
  background-color: #4a5254;
}
/*  */
.minnavWidth {
  overflow-y: auto;
}
.minlistdiv {
  height: 45px;
  background: #4a5254;
}
.minlistdiv div {
  height: 36px;
  line-height: 45px;
  text-align: center;
  color: #fff;
}
.minactivelist {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 8px 2px;
}
/*  */
.minscreen {
  display: none;
}
.maxscreen {
  display: block;
}
.activelist {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 8px 2px;
}
.listdiv {
  width: 120px;
  /* height: 39px; */
  text-align: center;
  line-height: 39px;
  color: #ffffff;
  display: inline-block;
  margin: 0px 2px;
  cursor: pointer;
  position: relative;
}
.listdiv:hover {
  /* background-color: #394040; */
  border-radius: 3px;
  transition: all 0.6s;
}

.overhidden {
  position: relative;
  width: 1116px;
  height: 45px;
  margin: auto;
  overflow: hidden;
}
.lefticon {
  font-size: 16px;
  width: 20px;
  height: 20px;
  top: 15px;
  position: absolute;
  left: 10px;
  z-index: 2000;
  color: #ffffff;
}
.righticon {
  font-size: 16px;
  width: 20px;
  height: 20px;
  top: 15px;
  left: 1170px;
  position: absolute;
  color: #ffffff;
}
.navpositionrelaAll {
  width: 100%;
  min-width: 1200px;
  height: 45px;
  display: flex;
  justify-content: center;
  background: #303030;
}
.navpositionrela {
  position: relative;
}

.allmenu {
  width: 1200px;
  /* margin: auto;
  display: flex;
  justify-content: center; */
}
.navWidth {
  margin: 3px auto;
  height: 45px;
  width: 1116px;
  white-space: nowrap;
  position: absolute;
  left: 0px;
}
.allWidth {
  background-color: #303030;
  height: 45px;
  /* box-shadow: 0 9px 11px rgba(0, 0, 0, 0.15), 0 0 19px rgba(0, 0, 0, 0.1); */
}
@media (min-width: 992px) and (max-width: 1199px) {
  .navpositionrelaAll {
    width: 100%;
    min-width: 992px;
  }
  .allmenu {
    width: 992px;
    margin: auto;
  }
  .overhidden {
    width: 868px;
  }
  .navWidth {
    width: 932px;
  }
  .righticon {
    width: 20px;
    left: 952px;
  }
  .lefticon {
    left: 20px;
  }
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: 768px) and (max-width: 991px) {
  .navpositionrelaAll {
    width: 100%;
    min-width: 768px;
  }
  .allmenu {
    width: 768px;
    margin: auto;
  }
  .overhidden {
    width: 744px;
  }
  .navWidth {
    width: 720px;
  }
  .righticon {
    width: 20px;
    left: 750px;
  }
  .lefticon {
    left: -3px;
  }
}
/*在480 和767 像素之间的屏幕里，超小屏幕，主要是手机*/
@media (min-width: 480px) and (max-width: 767px) {
  .navtopfixed {
    position: fixed;
    top: 0;
    left: 0;
    margin-top: 4px;
    margin-left: 15px;
    z-index: 999;
    background: #6e6b6b73;
    /* box-shadow: rgba(0, 0, 0, 0.227) 0px 3px 4px 2px; */
    padding: 6px;
    border-radius: 5px;
  }
  .minscreen {
    display: block;
    margin-left: auto;
    color: #fff;
  }
  .maxscreen {
    display: none;
  }
  .navpositionrelaAll {
    width: 100%;
    min-width: 480px;
  }
  .allmenu {
    width: 480px;
    margin: auto;
  }
  .overhidden {
    width: 370px;
  }
  .navWidth {
    width: 414px;
  }
  .righticon {
    width: 20px;
    left: 450px;
  }
}
/*在小于480px的屏幕里，微小屏幕，更低分辨率的手机*/
@media (max-width: 479px) {
  .navtopfixed {
    position: fixed;
    top: 0;
    left: 0;
    margin-top: 4px;
    margin-left: 15px;
    z-index: 999;
    background: #6e6b6b73;
    /* box-shadow: rgba(0, 0, 0, 0.227) 0px 3px 4px 2px; */
    padding: 6px;
    border-radius: 5px;
  }
  .minscreen {
    display: block;
    margin-left: auto;
    color: #fff;
  }
  .maxscreen {
    display: none;
  }
  .navpositionrelaAll {
    width: 100%;
    max-width: 479px;
  }
  .allmenu {
    width: 480px;
    margin: auto;
  }
  .overhidden {
    width: 370px;
  }
  .navWidth {
    width: 414px;
  }
  .righticon {
    width: 20px;
    left: 450px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/nav/nav.vue